var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcOutlineAccountCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 1.33334C4.32016 1.33334 1.3335 4.32001 1.3335 8.00001C1.3335 11.68 4.32016 14.6667 8.00016 14.6667C11.6802 14.6667 14.6668 11.68 14.6668 8.00001C14.6668 4.32001 11.6802 1.33334 8.00016 1.33334ZM4.90016 12.3333C5.7735 11.7067 6.84016 11.3333 8.00016 11.3333C9.16016 11.3333 10.2268 11.7067 11.1002 12.3333C10.2268 12.96 9.16016 13.3333 8.00016 13.3333C6.84016 13.3333 5.7735 12.96 4.90016 12.3333ZM12.0935 11.4133C10.9256 10.4975 9.48433 9.99975 8.00016 9.99975C6.516 9.99975 5.07471 10.4975 3.90683 11.4133C3.10493 10.4568 2.66587 9.24821 2.66683 8.00001C2.66683 5.05334 5.0535 2.66668 8.00016 2.66668C10.9468 2.66668 13.3335 5.05334 13.3335 8.00001C13.3335 9.30001 12.8668 10.4867 12.0935 11.4133Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 4C6.71317 4 5.6665 5.04667 5.6665 6.33333C5.6665 7.62 6.71317 8.66667 7.99984 8.66667C9.2865 8.66667 10.3332 7.62 10.3332 6.33333C10.3332 5.04667 9.2865 4 7.99984 4ZM7.99984 7.33333C7.4465 7.33333 6.99984 6.88667 6.99984 6.33333C6.99984 5.78 7.4465 5.33333 7.99984 5.33333C8.55317 5.33333 8.99984 5.78 8.99984 6.33333C8.99984 6.88667 8.55317 7.33333 7.99984 7.33333Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineAccountCircle);
export default __webpack_public_path__ + "static/media/ic_outline-account-circle.2b3a68b5cc1485cc54843434b23c9785.svg";
export { ForwardRef as ReactComponent };